
























































































import Vue from 'vue';
import { mask } from 'vue-the-mask';
import {
  Keybank,
  AchAccountType,
  AuthorizationType,
  KeyBankTransactionType,
} from '@/common/types/payments.types';
import { isCheckDigitRoutingNumberValid } from '@/common/validation/routingNumber.validation';

export default Vue.extend({
  props: {
    value: {
      type: Object as () => Keybank,
      required: true,
    },
    suffix: {
      type: String,
      required: true,
    },
    isoEditOrMerchant: {
      type: Boolean,
      required: false,
      default: false,
    },
    releasePaddingOffset: {
      type: Boolean,
      required: false,
    },
    getPage: {
      type: String,
      required: false,
      default: '',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCustomerVault: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      AchAccountType,
      isCheckDigitRoutingNumberValid,
    };
  },
  computed: {
    accountTypes(): { text: string; value: AchAccountType }[] {
      return [
        {
          text: (this.$options.filters as any).capitalize(AchAccountType.CHECKING),
          value: AchAccountType.CHECKING,
        },
        {
          text: (this.$options.filters as any).capitalize(AchAccountType.SAVINGS),
          value: AchAccountType.SAVINGS,
        },
      ];
    },
    authType(): { text: AuthorizationType; value: string }[] {
      return [
        {
          text: AuthorizationType.INPERSON,
          value: KeyBankTransactionType.PPD,
        },
        {
          text: AuthorizationType.ONPHONE,
          value: KeyBankTransactionType.TEL,
        },
      ];
    },
    routingNumberName(): string {
      return `routingNumber-${this.suffix}`;
    },
    accountNumberName(): string {
      return `accountNumber-${this.suffix}`;
    },
    accountTypeName(): string {
      return `accountType-${this.suffix}`;
    },
    authTypeName(): string {
      return `authType-${this.suffix}`;
    },
  },
  directives: {
    mask: {
      bind(el, binding, vnode, oldVnode) {
        if (binding.value) {
          mask(el, binding, vnode, oldVnode);
        }
      },
    },
  },
});
